import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // הגנה אם i18n לא מאותחל
    if (!i18n || typeof i18n.changeLanguage !== "function") {
      console.error("i18n לא מאותחל כמו שצריך:", i18n);
      return;
    }

    i18n.changeLanguage(lng);

    // עדכון כיוון שפה
    document.documentElement.lang = lng;
    document.documentElement.dir =
      lng === "he" || lng === "ar" ? "rtl" : "ltr";

    // שמירה ב־localStorage
    localStorage.setItem("language", lng);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("language");

    if (savedLang) {
      changeLanguage(savedLang);
    }
  }, []);

  return (
    <select
      value={i18n?.language || "he"}
      onChange={(e) => changeLanguage(e.target.value)}
      // className="px-2 py-1 rounded bg-white text-black text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      className="absolute left-3 top-5 px-2 py-1 rounded bg-white text-black text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <option value="he">עברית</option>
      <option value="en">English</option>
      <option value="ar">العربية</option>
    </select>
  );
};

export default LanguageSwitcher;